import React, { Children, cloneElement, isValidElement, useState } from "react";
import { ChevronDown, MinusSquare, PlusSquare } from "react-feather";
import classNames from "classnames";

export function AccordionSmall({
  children,
  title,
  byline,
  className = "",
  titleClass = "",
  containerClass = "",
  open = false,
}) {
  const [isActive, setIsActive] = useState(open);

  return (
    <div
      className={classNames(
        containerClass,
        "flex w-full flex-col items-stretch justify-start border border-gray-400 border-opacity-10 p-3 shadow-sm",
      )}
    >
      <header
        className="flex w-full cursor-pointer flex-row items-center justify-between gap-3"
        onClick={() => setIsActive(!isActive)}
      >
        <div className="flex flex-col">
          <h5 className={classNames(titleClass, "text-lg font-bold")}>
            {title}
          </h5>
          <div>{byline}</div>
        </div>
        {isActive ? <MinusSquare /> : <PlusSquare />}
      </header>
      <div
        className={classNames(
          className,
          isActive ? "block" : "hidden",
          "relative h-full w-full pt-3",
        )}
      >
        {children}
      </div>
    </div>
  );
}
